Ext.define('SA.lq.ControllerFactory', {
    singleton: true,

    createController({model, locationAliasListener, customLocationListener}) {
        var controller = new SA.lq.Controller({
            model,
            locationAliasListener,
            customLocationListener,

            controllers: {
                view: SA.lq.view.ViewControllerFactory.createController({model}),

                edit: SA.lq.edit.EditControllerFactory.createController({
                    model,
                    editDoneBtnClickHandler: () => SA.AppController.showProjectView(model)
                })
            }
        });

        locationAliasListener.setCallback(aliasChange => controller.onLocationAliasChange(aliasChange));
        locationAliasListener.listen();

        customLocationListener.setCallback(() => controller.onCustomLocationChange());

        return controller;
    }
});